import styled from 'styled-components';

export const ButtonGroup = styled.div`
  display: flex;

  button {
    flex: 1;
  }
`;
